import {
  OrgRole,
  OrgRoleRequestGatedAction,
  OrgRoleRequestSource,
} from "@hex/common";
import { Placement } from "@popperjs/core";
import React from "react";

import { HexTooltip } from "../../hex-components";
import { HexToolTipProps } from "../../hex-components/HexTooltip";
import { OrgRoleRequestButton } from "../app/OrgRoleRequestButton";

export const RoleRequestTooltip = React.memo(function RoleRequestTooltip({
  children,
  contentText,
  disabled,
  gatedAction,
  placement,
  requestSource,
  role,
  targetTagName,
}: {
  children: React.ReactNode;
  gatedAction: OrgRoleRequestGatedAction;
  requestSource: OrgRoleRequestSource;
  role?: OrgRole;
  disabled: boolean;
  contentText: string;
  placement?: Placement;
  targetTagName?: HexToolTipProps["targetTagName"];
}) {
  return (
    <HexTooltip
      content={
        <>
          <div css="min-width: 200px;">{contentText}</div>
          <OrgRoleRequestButton
            css={`
              margin: 6px 0 3px;
              width: 100%;
            `}
            gatedAction={gatedAction}
            requestSource={requestSource}
            role={role}
          />
        </>
      }
      disabled={disabled}
      interactionKind="hover"
      placement={placement}
      targetTagName={targetTagName}
    >
      {children}
    </HexTooltip>
  );
});
